'use client';

import { SessionProvider, type SessionProviderProps } from 'next-auth/react';
import type { ReactNode } from 'react';

/**
 * Wrapper client-component del SessionProvider de Auth.js v5.
 * Permite usar `useSession()` en client components como el Header.
 *
 * La sesión inicial se hidrata server-side (ver app/layout.tsx) para evitar
 * flash de "sin sesión" en el primer render.
 */
type Session = NonNullable<SessionProviderProps['session']>;

export function NqoroSessionProvider({
  session,
  children,
}: {
  session: Session | null;
  children: ReactNode;
}) {
  return (
    <SessionProvider session={session} refetchInterval={0} refetchOnWindowFocus={false}>
      {children}
    </SessionProvider>
  );
}
